module.exports = __webpack_public_path__ + "img/wushuizhan.35b9bb39.jpg";